import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { quickReplyRoutes } from "./routes";

export const quickReplyRoute = [
  {
    path: quickReplyRoutes.message,
    lazy: async () => {
      const { QuickReplyMessagePage } = await import("./QuickReplyMessagePage");

      return { element: <QuickReplyMessagePage /> };
    },
  },
  {
    path: quickReplyRoutes.ticket,
    lazy: async () => {
      const { QuickReplyTicketPage } = await import("./QuickReplyTicketPage");

      return { element: <QuickReplyTicketPage /> };
    },
  },

  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
